import { Component, ElementRef, Renderer2 } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons";
import { PlacementArray } from "@ng-bootstrap/ng-bootstrap/util/positioning";
import {
  IonicPage,
  LoadingController,
  ToastController,
  ViewController,
} from "ionic-angular";
import * as _ from "lodash";
import moment from "moment";
import { Subscription } from "rxjs";
import PatientChart from "../../../models/patient-chart/patientChartResponse";
import { CareTeamsService } from "../../../providers/care-teams-service/care-teams-service";
import { commonVar } from "../../../providers/common-var/common";
import { NavBarServiceProvider } from "../../../providers/nav-bar-service/nav-bar-service";
import { ReferralsServiceProvider } from "../../../providers/patient-charts/referrals-service";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import { Hospice } from "../../models/hospice";
import { CertificationService } from "../../services/certification-service";
import { AuthService } from "./../../../app/auth/auth.service";

@IonicPage()
@Component({
  selector: "page-referral-certification",
  templateUrl: "referral-certification.html",
})
export class ReferralCertificationModal {
  protected hasValidUsername = false;
  private physicianData = {};
  private hospice: Hospice;
  private patientChart: PatientChart;

  public showPhysicianOptions = false;
  public physicianOptions: any[] = [];

  private patientSubscription: Subscription;

  spinner: any = null;
  spinnerCounter: number = 0;
  selectedPhysician: any;
  patientId: string;
  patientData: any;
  attestationPatient;
  obtainedFromUser: string;
  currentUserFullName: string;
  currentUserQbosId: number;
  currentUsercredentials: string;
  usersData: any;
  staffeCredential: string;
  credentialToggleOn: any;
  obtainedFromUserQbosId: number;

  certificationForm: FormGroup;

  currentDate = new Date();
  currentDateFormat = {
    year: this.currentDate.getFullYear(),
    month: this.currentDate.getMonth() + 1,
    day: this.currentDate.getDate(),
  };

  minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 100));
  minDateFormat = {
    year: this.minDate.getFullYear(),
    month: this.minDate.getMonth() + 1,
    day: this.minDate.getDate(),
  };

  maxDate = new Date(new Date().setFullYear(new Date().getFullYear() + 100));
  maxDateFormat = {
    year: this.maxDate.getFullYear(),
    month: this.maxDate.getMonth() + 1,
    day: this.maxDate.getDate(),
  };

  startMinDate: any = this.minDateFormat;
  startMaxDate: any = this.currentDateFormat;

  endMinDate: any = this.currentDateFormat;
  endMaxDate: any = this.maxDateFormat;

  datePlacementPreference: PlacementArray = ["left-top"];
  requiredIcon = faAsterisk;

  public physicians: any[] = [];
  public disabledBtn = false;
  constructor(
    public referralsService: ReferralsServiceProvider, // TODO: Replace with new cert service phys lookup
    private viewCtrl: ViewController,
    private stateData: StateManagementService,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private certificationSvc: CertificationService,
    private navBarService: NavBarServiceProvider,
    private careTeamService: CareTeamsService,
    private authSvc: AuthService
  ) {
    this.certificationForm = new FormGroup({
      certificationFrom: new FormControl(""),
      certificationTo: new FormControl(""),
      obtainedFrom: new FormControl("", Validators.required),
      obtainedFromDate: new FormControl("", Validators.required),
      staffSignature: new FormControl(
        "",
        Validators.compose([Validators.required, Validators.maxLength(150)])
      ),
      staffSignatureDate: new FormControl("", Validators.required),
    });

    this.hospice = null;

    this.certificationSvc.getHospiceInfo().subscribe((data) => {
      this.hospice = data;
    });

    this.patientId = this.stateData.getChartId();
    this.patientData = this.stateData.selectedPatientData;
    this.patientChart = this.navBarService.getPatientChart();

    // A little hacky right now --- but pulls new patient chart from the nav bar
    // or pulls the old from IDG
    // BBP - 1/9/2019
    if (this.patientChart) {
      this.attestationPatient = {
        name: this.patientChart.patient.fullName,
        id: this.patientChart.externalId,
      };
    } else {
      this.patientId = window.location.href.split("/")[5];
      this.patientSubscription = careTeamService
        .getPatientInfo(this.navBarService.getExternalId().toString())
        .subscribe((x) => {
          this.patientData = x;
          this.attestationPatient = {
            name: this.patientData.displayName,
            id:
              this.patientData.patientChart === undefined
                ? 0
                : this.patientData.patientChart.qbosId,
          };
        });
    }

    this.certificationForm
      .get("staffSignature")
      .valueChanges.subscribe((val) => {
        this.hasValidUsername = val === this.currentUserFullName;
      });

    this.certificationForm.get("obtainedFrom").valueChanges.subscribe((val) => {
      this.searchPhysician(val, "obtainedFrom");
    });
  }

  protected retrieveUser() {
    const user = this.authSvc.getUser();
    this.currentUserFullName = user.name;
    this.currentUserQbosId = user.userId;
  }
  searchPhysician(searchTerm: string, fieldName: string) {
    let options = [];
    let showFlag = false;
    if (searchTerm && searchTerm.length > 2 && this.physicians) {
      showFlag = true;
      if (this.credentialToggleOn == true) {
        options = this.physicians
          .map((physician) => {
            return {
              name:
                (physician.firstName + " " + physician.lastName).toLowerCase() +
                "(" +
                physician.credentials +
                ")",
              firstName: physician.firstName,
              lastName: physician.lastName,
              credentials: physician.credentials,
              personId: physician.personId,
            };
          })
          .filter((data) => {
            return (
              data.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
            );
          });
      } else {
        options = this.physicians
          .map((physician) => {
            return {
              name: (
                physician.firstName +
                " " +
                physician.lastName
              ).toLowerCase(),
              firstName: physician.firstName,
              lastName: physician.lastName,
              id: physician.id,
              qbosId: physician.qbosId,
            };
          })
          .filter((data) => {
            return (
              data.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
            );
          });
      }
      this.setPhysicianOptions(
        _.sortBy(options, "lastName"),
        showFlag,
        fieldName
      );
    } else {
      this.setPhysicianOptions(options, showFlag, fieldName);
    }
  }

  setPhysicianOptions(options: string[], showFlag: boolean, fieldName: string) {
    switch (fieldName) {
      case "obtainedFrom":
        this.physicianOptions = options;
        this.showPhysicianOptions = showFlag;
        break;
      default:
    }
  }

  setPhysician(phys, control: string) {
    const physControl = this.certificationForm.get(control);
    if (physControl) {
      if (this.credentialToggleOn == true) {
        physControl.setValue(
          `${phys.firstName}, ${phys.lastName} (${phys.credentials})`
        );
        this.obtainedFromUser = phys.lastName + " " + phys.firstName;
        this.obtainedFromUserQbosId = phys.personId;
      } else {
        physControl.setValue(`${phys.firstName} ${phys.lastName}`);
      }
      this.physicianData[control] = phys;
      this.showPhysicianOptions = false;
    }
  }

  ngOnInit() {
    this.credentialToggleOn = this.navBarService.credentialFeatureToggleOn();
    this.renderer.addClass(
      this.elRef.nativeElement.parentNode,
      "modal-cti-confirmation"
    );
    this.retrieveUser();

    if (this.credentialToggleOn == true) {
      this.certificationSvc.getPhysicianDataCredential().subscribe(
        (response: string[]) => {
          this.physicians = response;
        },
        (err) => {}
      );
      this.certificationSvc.getUsers(this.currentUserQbosId).subscribe(
        (response: string[]) => {
          this.usersData = response[0];
          this.staffeCredential = this.usersData.type;
        },
        (err) => {}
      );
    } else {
      this.certificationSvc.getPhysicianData().subscribe(
        (response: string[]) => {
          this.physicians = response;
        },
        (err) => {}
      );
    }
  }

  onSubmit() {
    this.disabledBtn = true;
    const payload = {
      origin: "REFERRAL",
      type: "VERBAL_REFERRAL",
      patientQbosId: parseInt(this.patientId),
      obtainedFromQbosId: this.credentialToggleOn
        ? this.obtainedFromUserQbosId
        : parseInt(this.physicianData["obtainedFrom"].qbosId),
      obtainedFromId: this.credentialToggleOn
        ? this.currentUserQbosId
        : parseInt(this.physicianData["obtainedFrom"].id),
      periodStartDateTime: moment
        .utc(this.certificationForm.get("certificationFrom").value)
        .hour(0)
        .minute(0)
        .second(0)
        .toISOString(),
      periodEndDateTime: moment
        .utc(this.certificationForm.get("certificationTo").value)
        .hour(0)
        .minute(0)
        .second(0)
        .toISOString(),
      obtainedFromName: this.credentialToggleOn
        ? this.obtainedFromUser
        : this.certificationForm.get("obtainedFrom").value,
      obtainedSignedDate: moment(
        new Date(this.certificationForm.get("obtainedFromDate").value)
      )
        .hour(new Date().getHours())
        .minute(new Date().getMinutes())
        .second(new Date().getSeconds())
        .toISOString(),
      staffSignature: this.credentialToggleOn
        ? this.currentUserFullName
        : this.certificationForm.get("staffSignature").value,
      staffSignedDate: moment(
        new Date(this.certificationForm.get("staffSignatureDate").value)
      )
        .hour(new Date().getHours())
        .minute(new Date().getMinutes())
        .second(new Date().getSeconds())
        .toISOString(),
      hospice: this.hospice,
    };

    this.certificationSvc.Referral_createVerbalCti(payload).subscribe(
      (response) => {
        if (response) {
          this.referralsService.CERTIFICATE_ICON = commonVar.COMPLETED_ICON;
          this.viewCtrl.dismiss({
            created: true,
            cancel: false,
          });
        }
        this.disabledBtn = false;
      },
      (err) => {
        this.presentToast(err.message);
        this.disabledBtn = false;
      }
    );
  }

  onDismiss() {
    this.viewCtrl.dismiss({ cancel: true });
    this.disabledBtn = false;
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "below",
      cssClass: "error",
    });

    toast.onDidDismiss(() => {});

    toast.present();
  }

  // incremental loader function
  increaseSpinnerCount(message: string = "Creating Assessment...") {
    this.spinnerCounter++;
    if (this.spinnerCounter && this.spinner == null) {
      this.spinner = this.loadingCtrl.create({
        content: message,
      });
      this.spinner.present();
    }
  }

  // decremental loader function
  decreaseSpinnerCount() {
    this.spinnerCounter--;
    if (this.spinnerCounter <= 0) {
      this.spinner.dismiss();
      this.spinner = null;
    }
  }

  ionViewDidLeave() {
    if (this.patientSubscription) {
      this.patientSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/certification/forms/referral-certification/referral-certification.ts